import React from "react";
import { Coins } from "lucide-react";
import DashboardCommonBgCard from "./common/DashboardCommonBgCard";
import { useGetDealsSummary } from "../hooks/useGetDashboardApi";

const cards = [
  {
    key: "deals_added",
    label: "Deals Added",
    description: "Total deals in your pipeline",
    dot: "bg-warning-500",
  },
  {
    key: "deals_won",
    label: "Deals Won",
    description: "Deals successfully closed",
    dot: "bg-success-500",
    valueClass: "text-success-500",
  },
  {
    key: "deals_stuck",
    label: "Deals Stuck",
    description: "Past-due deals still in process",
    dot: "bg-orange-500",
  },
  {
    key: "deals_lost",
    label: "Deals Lost",
    description: "Deals marked as lost",
    dot: "bg-error-500",
  },
];

const formatCount = (value) => String(Number(value || 0)).padStart(2, "0");

const DealsSummary = () => {
  const { data, isPending, isError } = useGetDealsSummary();

  return (
    <DashboardCommonBgCard
      title="Deals Summary"
      icon={<Coins size={18} strokeWidth={1.5} className="text-secondary" />}
      tooltipContent="Deals Stuck are in-process deals whose estimated closing date has passed."
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {cards.map((card) => (
          <div
            key={card.key}
            className="flex min-h-[88px] items-center justify-between gap-4 rounded-lg bg-gray-50 dark:bg-gray-800/60 border border-gray-100 dark:border-gray-800/60 p-4"
          >
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <span className={`h-2 w-2 rounded-full ${card.dot}`} />
                <h4 className="text-sm font-medium text-gray-800 dark:text-gray-100">
                  {card.label}
                </h4>
              </div>
              <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">{card.description}</p>
            </div>
            <span
              className={`text-2xl font-bold ${card.valueClass || "text-gray-800 dark:text-gray-100"}`}
            >
              {isPending ? "—" : formatCount(data?.[card.key])}
            </span>
          </div>
        ))}
      </div>
      {isError && (
        <p className="mt-2 text-xs text-error-500">
          Unable to load the deals summary.
        </p>
      )}
    </DashboardCommonBgCard>
  );
};

export default DealsSummary;
